module.exports = __webpack_public_path__ + "static/img/celoscope-15.c3a4ec4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-15.jpg
// module id = 8tjb
// module chunks = 52